import Component from '@/store/Component.js'

export default class Collide extends Component {
  static create (options = {}) {
    return {
      kind: 'collide',
      test: options.test || false,
      shape: options.shape || 'circle',
      radius: options.radius || undefined,
      points: options.points || undefined,
      from: options.from || undefined,
      to: options.to || undefined,
      followUid: options.followUid || undefined,
      details: options.details || false,
      collision: undefined,
      result: undefined
    }
  }
}
